import React, { useEffect, useState } from 'react';
import AssetActivityTimeline from './AssetActivityTimeline';
import { useAssetListStore } from 'contexts/RootStore.context';
import { Asset, AssetActivity } from 'types/asset';
import LoadingScreen from 'components/Loading/LoadingScreen';


export default function AssetActivityTabContent({ asset }: { asset: Asset }) {
  const { assetActivities, loadAssetActivities } = useAssetListStore()

  const [activityList, setActivityList] = useState<AssetActivity[] | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    if (assetActivities[asset.asset_id]) {
      setActivityList(assetActivities[asset.asset_id])
      setLoading(false)
    }
    loadAssetActivities(asset.asset_id).then(() => {
      setActivityList(assetActivities[asset.asset_id])
      setLoading(false)
    })
  }, [asset.asset_id, assetActivities, loadAssetActivities])

  if (loading || !activityList) {
    return <LoadingScreen />
  }

  return (
    <AssetActivityTimeline activityList={activityList} />
  );
}
